import React, { useState } from 'react';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth, db } from './Firebse'; // Correct spelling to 'Firebase'
import { setDoc, doc } from 'firebase/firestore';
import NavBtns from '../../Components/NavBtns';
import googleImage from '../../assets/Google.png'; // Adjust the path as necessary

const SignUpGoogle = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function googleLogin() {
    setLoading(true);
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // Instead of window.location.href, use navigate from react-router-dom
      window.location.href = '/scoreboard'; 
      if (user) {
        await setDoc(doc(db, 'Users', user.uid), {
          email: user.email,
          firstName: user.displayName,
          lastname: '',
        });
      }
    } catch (err) {
      console.error('Error during sign in:', err);
      setError('Failed to sign in. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <NavBtns />
      <div className="bg-ctr register-form" style={{ backgroundColor: 'none' }}>
        <form className="register-css">
          <h3>SignUp</h3>
          <p>Typeathon</p>

          {error && <div className="error-message">{error}</div>}

          <div
            style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
            onClick={googleLogin}
          >
            {loading ? (
              <p>Loading...</p>
            ) : (
              <img src={googleImage} alt="Google Sign-In" width="100%" />
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default SignUpGoogle;
